import { Logger } from '@gplibraries/react/utils';
import { datadogRum } from "@datadog/browser-rum";

export default function createLogger() {

  // Read log level from local storage
  const storage = localStorage.getItem('log_level');
  const logLevel = storage ?? 'info';
  if (!storage) {
    // setting local storage key if it doesn't exist so we can easily manipulate it later
    localStorage.setItem('log_level', logLevel);
  }

  const logger = new Logger(logLevel);

  // send error messages to Data Dog;
  logger.addErrorLogHandler((error, context) => {
    datadogRum.addError(error, context)
  });

  return logger;

}